// extracted by mini-css-extract-plugin
module.exports = {"var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","gridOverrides":"gridOverrides--18d30","variant":"variant--9dd5c"};